import React from 'react';
import PropTypes from 'prop-types';

import { buildSlotFills, PolicyCardSlot } from './slots';

const slotFills = buildSlotFills(import.meta.glob('../**/*.policy-card-slot.jsx', { eager: true }));

export const hasSlotFills = (name) => Boolean(slotFills[name]?.length);

// Renders every fill for one named slot on the policy card, or nothing while the slot is empty.
const Slot = ({ name, policy }) => {
  const fills = slotFills[name];
  if (!fills?.length) {
    return null;
  }
  return fills.map((Fill, index) => <Fill key={index} policy={policy} />);
};

Slot.propTypes = {
  name: PropTypes.oneOf(Object.values(PolicyCardSlot)).isRequired,
  policy: PropTypes.object.isRequired
};

export default Slot;
